export const EcomGTMEventNames = {
  PAGE_VIEWED: 'Page Viewed',
  HEADER: {
    CART_ICON: 'cart_icon_clicked',
  },
  CHECKOUT: {
    ORDER_SUMMARY: {
      EDIT_CART: 'edit_cart',
    },
    ADD_SHIPPING_INFO: 'add_shipping_info',
    CONTINUE_PAYMENT_BUTTON: 'continue_payment',
  },
  CART: {
    CART_SCREEN_LANDED: 'cart_screen_landed',
    BEGIN_CHECKOUT: 'begin_checkout',
  },
  PAYMENT: {
    PAYMENT_SUCCESS_LANDED: 'Payment_Success_Landed',
    PURCHASE: 'purchase',
  },

  PDP: {
    PREXO_SELECTION_STARTED: 'prexo_selection_started',
    PREXO_SELECTION_COMPLETED: 'prexo_selection_completed',
    COUPON_APPLY_STARTED: 'coupon_apply_started',
    PRODUCT_INFORMATION: 'product_information',
    ADD_TO_CART: 'add_to_cart',
    VARIANT_CHANGED: 'variant_changed',
  },

  ORDER: {
    CANCEL: {
      INITIATED: 'Order_Cancel_Initiated',
      MODAL_BUTTON_CLICKED: 'Order_Cancel_Modal_Button_Clicked',
      MODAL_BACK_BUTTON_CLICKED: 'Order_Cancel_Modal_Back_Button_Clicked',
      REASONS_SELECTED_BUTTON_CLICKED: 'Order_Cancel_Reasons_Selected_Button_Clicked',
      REASONS_SELECTED_MODAL_BACK_BUTTON_CLICKED:
        'Order_Cancel_Reasons_Selected_Modal_Back_Button_Clicked',
      SUCCESS_SCREEN_LANDED: 'Order_Cancel_Success_Screen_Landed',
      FIRST_MODAL_OPENED: 'Order_Cancel_First_Modal_Opened',
      REASONS_MODAL_OPENED: 'Order_Cancel_Reasons_List_Modal_Opened',
    },

    RETURN: {
      INITIATED: 'Order_Return_Initiated',
      SUCCESS_SCREEN_LANDED: 'Order_Return_Success_Screen_Landed',
    },
  },

  FREE_SERVICE: 'Paid_SR_Created',
};

export enum ECOM_SCREEN_NAMES {
  CART_PAGE = 'Cart',
  CHECKOUT_PAGE = 'Checkout',
  HOME = 'Home',
  PDP_PAGE = 'PDP',
  PROFILE_PAGE = 'Profile',
  CATEGORY_PAGE = 'Category',
  SUBCATEGORY_PAGE = 'Sub Category',
  SEARCH_PAGE = 'Search Result Page',
  STORE_PAGE = 'Store',
  ORDERS_PAGE = 'Orders',
  ORDER_DETAILS_PAGE = 'Order Details',
  PAYMENT_WIDGET_PAGE = 'Payment Widget',
  ORDER_PAYMENT_STATUS_PAGE = 'Order Payment Status',
  LOGIN_PAGE = 'Login',
  BLOG_PAGE = 'Blog',
  BLOG_DETAIL_PAGE = 'Blog Detail',
  BLOG_CATEGORY_PAGE = 'Blog Category',
}

export enum SCA_SCREEN_NAMES {
  SCA_DASHBOARD = 'SCA Dashboard',
  SCA_STORE = 'SCA Store',
  SCA_TRAINING = 'SCA Training',
  SCA_PDP = 'SCA PDP',
  SCA_CATEGORY = 'SCA Category',
  SCA_SEARCH = 'SCA Search',
  SCA_ORDERS = 'SCA Orders',
  SCA_EARNINGS = 'SCA Earnings',
  SCA_WELCOME = 'SCA Welcome',
  SCA_ANALYTICS = 'SCA Analytics',
}
